// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b60ab51c","455":"962b6990","977":"1244af3e"}[chunkId] + ".chunk.js";
};